import { useGetAllUserPlaylistProgressQuery } from '../../../../__generated__/chirp/com/hubspot/learning/center/credentials/rpc/PlaylistVisibilityChirpService.hooks';
import { DEFAULT_PAGE_SIZE } from '../constants/pagination';
import I18n from 'I18n';
export const useRecentCompletedPlaylists = () => {
  const {
    data,
    loading,
    error
  } = useGetAllUserPlaylistProgressQuery({
    variables: {
      sortOrder: 'DESC',
      sortField: 'COMPLETED_DATE',
      offset: {
        offsetPosition: 0
      },
      pageLength: 25,
      status: 'COMPLETED'
    }
  });
  return {
    recentCompletedPlaylists: data === null || data === void 0 ? void 0 : data.results,
    recentCompletedPlaylistsLoading: loading,
    recentCompletedPlaylistsError: error
  };
};
export const useIncompletePlaylists = () => {
  const today = I18n.moment.userTz().startOf('day');
  const tenYearsAgo = I18n.moment.userTz().startOf('day').subtract(10, 'years');
  const {
    data,
    loading,
    error
  } = useGetAllUserPlaylistProgressQuery({
    variables: {
      sortOrder: 'DESC',
      sortField: 'DUE_DATE',
      offset: {
        offsetPosition: 0
      },
      pageLength: 25,
      status: 'INCOMPLETE',
      dueDate: {
        startDate: tenYearsAgo.valueOf(),
        endDate: today.valueOf()
      }
    }
  });
  return {
    incompletePlaylists: data === null || data === void 0 ? void 0 : data.results,
    incompletePlaylistsLoading: loading,
    incompletePlaylistsError: error
  };
};
export const usePlaylistAssignments = ({
  pageLength = DEFAULT_PAGE_SIZE,
  offset = 0,
  sortOrder = 'ASC',
  sortField = 'PLAYLIST_NAME',
  playlistNameQuery,
  teams,
  users,
  playlists,
  status,
  assignedBy,
  dueDate,
  completedAt
}) => {
  const {
    data,
    loading,
    error,
    previousData
  } = useGetAllUserPlaylistProgressQuery({
    variables: Object.assign({
      sortOrder,
      sortField
    }, playlistNameQuery ? {
      playlistNameQuery
    } : {}, teams && teams.length > 0 ? {
      teams
    } : {}, users && users.length > 0 ? {
      teamMembers: users
    } : {}, playlists && playlists.length > 0 ? {
      playlists
    } : {}, {
      offset: {
        offsetPosition: offset
      },
      pageLength
    }, status ? {
      status
    } : {}, {
      assignedBy
    }, dueDate ? {
      dueDate
    } : {}, completedAt ? {
      completedAt
    } : {})
  });
  return {
    playlistAssignments: data,
    playlistAssignmentsLoading: loading,
    playlistAssignmentsError: error,
    previousData
  };
};